<template>
  <div>

    <xolas-table
      table-ref="utilrpttable"

      :title="utilLabel + ' Bill Report'"
      icon="fa fa-plug"

      url="/report/utility/summary"
      :fields="fields"

      sort-field="siteName"

      :show-refresh="false"
      :show-search="false"

      :layer-component="isTowerCo() ? 'utilityReport' : null"
      :layer-args="{ id: 'id' }">

    </xolas-table>

  </div>
</template>

<script>

import {settings} from '@/components/Data'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'
import PostMixins from '@/mixins/PostMixins'

export default {
  mixins: [DateMixins, NumberMixins, PostMixins],

  data () {
    return {
      format: settings.selectDateFormat,
      currency: settings.currency,
      utilLabel: this.getUtilLabel(),
      taxLabel: settings.taxName,
      amountLabel: settings.utilAmountLabel,
      extraChargesLabel: settings.utilExtraInputLabel,
      extraCalcTotal: settings.utilExtraInputTotal,
      site: {sharers: []},
      rates: [],
      // minWidth = round(0.7 x the pre-migration vuetable-2 column width), measured at a
      // 1504px viewport (XOL-397 baseline: docs/plans/2026-10-26-xol-397-utility-report-drawer.md,
      // "Measured baseline") — el-table distributes un-sized columns equally, which does not
      // match the legacy content-based auto layout. Columns hidden at 1504px
      // (hidden-lg-and-down: Bills, Paid, Balance O/S) measure 0 there, so they get no minWidth.
      fields: [
        {
          name: 'period',
          title: 'Period',
          minWidth: 99
        },
        {
          name: 'siteId',
          title: 'Site ID',
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: 75
        },
        {
          name: 'siteName',
          title: 'Site Name',
          minWidth: 242
        },
        {
          name: 'sharers',
          title: 'Site Sharers',
          dataClass: 'text-bold text-center',
          callback: this.formatInteger,
          minWidth: 90
        },
        {
          name: 'penalties',
          title: 'Penalties',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down text-muted',
          callback: this.formatNumber,
          minWidth: 70
        },
        {
          name: 'amount',
          title: 'Amount',
          dataClass: 'text-bold text-right',
          callback: this.formatNumber,
          minWidth: 62
        },
        {
          name: 'extraCharges',
          title: settings.utilExtraInputLabel,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down text-muted text-right',
          callback: this.formatNumber,
          minWidth: 58
        },
        {
          name: 'tax',
          title: settings.taxName,
          visible: this.showTax(),
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down text-muted text-right',
          callback: this.formatNumber,
          minWidth: 32
        },
        {
          // XOL-397 (D8, Carlos 2026-10-26): Non-Tax is the bill's un-taxed charges. Before
          // XOL-397 this was a second `extraCharges` field, so the column repeated
          // utilExtraInputLabel's value (KWTBB) instead of showing untaxedCharges.
          name: 'untaxedCharges',
          title: 'Non-Tax',
          visible: this.showTax(),
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down text-muted text-right',
          callback: this.formatNumber,
          minWidth: 62
        },
        {
          name: 'total',
          title: 'TOTAL',
          dataClass: 'text-primary text-bold text-right',
          callback: this.formatNumber,
          minWidth: 62
        },
        {
          name: 'totalBillsPeriod',
          title: 'Bills',
          titleClass: 'hidden-lg-and-down',
          dataClass: 'hidden-lg-and-down text-center'
        },
        {
          name: 'paidBillsPeriod',
          title: 'Paid',
          titleClass: 'hidden-lg-and-down',
          dataClass: 'hidden-lg-and-down text-center'
        },
        {
          name: 'totalPaid',
          title: 'Total Paid',
          titleClass: 'hidden-sm-and-down',
          // text-right, not the legacy pull-right: pull-right floats the cell (and, via
          // XolasTable's class-name, its header) out of the table grid, so the column looked
          // detached from the report (Carlos, 2026-10-26 — D15).
          dataClass: 'hidden-sm-and-down text-success text-right',
          callback: this.formatNumber,
          minWidth: 74
        },
        {
          name: 'amountDue',
          title: 'Balance O/S',
          titleClass: 'hidden-lg-and-down',
          dataClass: 'hidden-lg-and-down text-warning text-right',
          callback: this.formatNumber
        }
      ]
    }
  }
}
</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
